var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHelpFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0Zm0 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM9 3C6.503 3 5.306 4.594 5.034 5.608a1 1 0 0 0 1.932.517C7.028 5.895 7.499 5 9 5c.966 0 1.43.345 1.669.632.133.16.22.33.272.476.057.16.059.248.059.225 0 .506-.13.832-.292 1.066-.172.25-.42.455-.736.652a9.198 9.198 0 0 1-.497.282c-.164.088-.361.193-.535.3-.26.163-.94.6-.94 1.433V11a1 1 0 0 0 2 0v-.67c.107-.066.238-.136.424-.236a11.1 11.1 0 0 0 .604-.345c.434-.27.936-.648 1.326-1.215.402-.582.646-1.307.646-2.201 0-.461-.203-1.272-.794-1.981C11.57 3.589 10.533 3 9 3Z"
})));
export default SvgIconHelpFilled;